<template>
  <div class="myelements-card-duration">
    {{ duration }}
  </div>
</template>
<script>
export default {
  name: 'MyelementsCardDuration',
  props: {
    duration: {
      type: String,
      default: ''
    }
  }
};
</script>
<style lang="scss" scoped>
.myelements-card-duration {
  position: absolute;
  right: 7px;
  bottom: 7px;
  width: 44px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 10px;
  z-index: 2;
}
</style>
